import { observer } from "mobx-react-lite";
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import Clicker from "../components/ui/Clicker";
import Dropbox from "../components/ui/Dropbox";
import { ReactComponent as Plus } from "../images/icons/plus.svg";
import { ReactComponent as Find } from "../images/icons/find.svg";
import { ReactComponent as Filter } from "../images/icons/filter.svg";
import RateOptionsAPI from "../API/RateOptionsAPI";
import RateOptionsCard from "../components/lists/rateOptionsCard";
import "../styles/setup.css";
import ParamField from "../components/ui/ParamField";
import SingleTable from "../components/tables/SingleTable";
import loans from "../settings/loans.json";
import SingleRow from "../components/tables/SingleRow";
import SwitcherParams from "../components/ui/SwitcherParams";
import { Context } from "..";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import useAssociationsEditor from "../hooks/useAssociationsEditor";
import useNotification from "../hooks/useNotification";
import useRateOptions from "../hooks/useRateOptions";

const RateOptions = () => {
    const { success, warning, error } = useNotification();
    const { store } = useContext(Context);

    const [isTaskView, setIsTaskView] = useState(true);

    const scrollElement = useRef(null);
    const [hasScroll, setHasScroll] = useState(true);
    
    const [loan, setLoan] = useState(0);
    const [objectsList, setObjectsList] = useState(null);
    const [newCell, setNewCell] = useState(null);

    const [isLoading, setisLoading] = useState(true);
    const [summParams, setSummParams] = useState([]);

    const [isOpenedDropbox, setIsOpenedDropbox] = useState(null);
    const [dropboxes, setDropboxes] = useState({
        loans: {
            values: loans.docs_count,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
    });
    const changeOpenedDropbox = (dropboxName, state) => {
        let newDropboxes = { ...dropboxes };
        if (isOpenedDropbox != null) newDropboxes[isOpenedDropbox].isOpened = false;
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], isOpened: state } }
        setDropboxes(newValue);

        if (state) setIsOpenedDropbox(dropboxName);
        else setIsOpenedDropbox(null);
    }
    const changeValueDropbox = (dropboxName, value) => {
        let newDropboxes = { ...dropboxes, [isOpenedDropbox]: { ...dropboxes[isOpenedDropbox], isOpened: false } };
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], currentValue: value } };
        setDropboxes(newValue);

        if (dropboxName != "association") return;
        changeAssociation(value != 0 ? newDropboxes.association.values[value].id : null);
    }

    const { rate_hourCost, loanSumm, rate_summ, rate_tasks, setRateValue, rate_changeAssociation } = useRateOptions(dropboxes.loans.values[dropboxes.loans.currentValue].value)

    const { associationsDropbox, changeAssociation } = useAssociationsEditor("loan_id");
    useEffect(() => {
        if (!associationsDropbox || associationsDropbox === null || !associationsDropbox.values || associationsDropbox.values.length === 0) return;
        rate_changeAssociation();
        setDropboxes({ ...dropboxes, association: associationsDropbox });
    }, [associationsDropbox]);

    useLayoutEffect(() => {
        // if (!isTaskView && scrollElement.current.scrollHeight > scrollElement.current.clientHeight) setHasScroll(true);
        loadData().then(() => console.log("Список задач загружен"));
    }, []);
    const loadData = async () => {
        try {
            const options = await RateOptionsAPI.getAll();
            for (let i = 0; i < options.data.options.length; i++) {
                options.data.options[i]["value"] = 0;
            }
            setObjectsList(options.data.options);
            setLoan(options.data.loan);
            setisLoading(false);
            setSummParams(Array.from({ length: options.data.options.length+1 }, (item) => 0));
            return options.data.options;
        } catch (err) {
            console.log("[main_keeper] [getAll] error:", err);
        }
    }

    // Редактирование опции
    const setValue = async (index, newValue, field) => {
        let oldArr = [...objectsList];
        oldArr[index] = {...objectsList[index], [field]: newValue};
        setObjectsList(oldArr);
    }
    const removeValue = async (index) => {
        try {
            let newObjects = objectsList;
            if (!newObjects[index].id) newObjects = await loadData();
            const response = await RateOptionsAPI.remove(newObjects[index].id);
            if (response.status !== 200) throw response;

            newObjects = newObjects.filter((item, itemIndex) => itemIndex !== index);
            setObjectsList([...newObjects]);
        } catch(err) {
            console.log("[x] Ошибка удаления тарифной опции:", err);
            error("Ошибка удаления тарифной опции");
        }
    }
    const saveValue = async (value) => {
        try {
            const response = await RateOptionsAPI.update(value);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log("[x] Ошибка обновления тарифной опции:", err);
            error("Ошибка сохранения тарифной опции");
        }
    }
    // Сохдание новой тарифной опции
    const addingValue = () => {
        setNewCell({ 
            name: "", 
            isMulti: false, 
            cost: 0 
        });
    }
    const setValueNewCell = async (value, field) => {
        let newValue = newCell;
        newValue[field] = value;
        setNewCell({ ...newValue });
    }
    const saveNewCell = async (value) => {
        try {
            const response = await RateOptionsAPI.create(value);
            if (response.status !== 200) throw response;

            let newObjects = await loadData();
            setObjectsList(newObjects);
            setNewCell(null);
        } catch (err) {
            console.log("Ошибка создания строки в ГБ:", err);
            error("Ошибка создания тарифной опции");
        }
    }

    const updateLoan = async (loan) => {
        try {
            const response = await RateOptionsAPI.updateLoan({ loan: loan });
            if (response.status !== 200) throw response; 
        } catch (err) {
            console.log("[x] Ошибка обновления параметра займов:", err);
            error("Ошибка сохранения параметра времени");
        }
    }
    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="setupBlock">
            <div className="managementMenu">
                <button className="activeButton" onClick={() => window.location.replace("/calc")}>Назад</button>
                <MultiSwitcherStage
                    values={[{ name: "Тарифные опции" }, { name: "Займы" }]}
                    defaultValue={isTaskView ? 0 : 1}
                    forceSelected={isTaskView ? 0 : 1}
                    selectValue={(newValue) => setIsTaskView(newValue == 0 ? true : false)}
                />
            </div>
            <div className="setupContent">
                <div className="paramsBlock">
                    <div className="title">Тарифные опции</div>
                    { dropboxes.association && <div className={`paramsList${dropboxes.association.currentValue === 0 ? " error" : ""}`} style={{ flex: 0 }}>
                        <div className="title">Займы</div>
                        <ul>
                            <li>
                                <div className="params" style={{ width: 430 }}>
                                    <div className="title">Ответственный</div>
                                    <div className="attribute">
                                        <Dropbox 
                                            textValue={dropboxes.association.values[dropboxes.association.currentValue]?.name}
                                            isRight={true}
                                            isOpen={dropboxes.association.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("association", value)}
                                            isError={dropboxes.association.currentValue === 0}
                                        >
                                            {dropboxes.association.values.map((item, index) => <li 
                                                className={dropboxes.association.currentValue === index || (dropboxes.association.currentValue === null && index == 0) ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("association", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div> }
                    <div className="paramsList" style={{ overflowX: "hidden", overflowY: "auto" }}>
                        <ul>
                            <li>
                                <div className="params" style={{ width: 430 }}>
                                    <div className="title">Займы</div>
                                    <div className="attribute"><Dropbox 
                                        textValue={dropboxes.loans.values[dropboxes.loans.currentValue].name}
                                        isRight={true}
                                        isOpen={dropboxes.loans.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("loans", value)}
                                    >
                                        {dropboxes.loans.values.map((item, index) => <li 
                                            className={dropboxes.loans.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => {
                                                changeValueDropbox("loans", index)
                                                let newSumm = [...summParams];
                                                newSumm[0] = Math.ceil(dropboxes.loans.values[index].value * loan * (rate_hourCost / 60));
                                                setSummParams(newSumm);
                                            }}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox></div>
                                </div>
                                <div className="summ">{formatNumber(Math.ceil(dropboxes.loans.values[dropboxes.loans.currentValue].value * loan * (rate_hourCost / 60)))} ₽</div>
                            </li>
                            { objectsList && objectsList.map((item, index) => <li key={item+index}>
                                <div className="params" style={{ width: 430 }}>
                                    <div className="title">{item.name}</div>
                                    <div className="attribute">{item.isMulti
                                        ? <Clicker 
                                                min={0} 
                                                setValue={(newValue) => {
                                                    setValue(index, newValue, "value");
                                                    let newSumm = [...summParams];
                                                    newSumm[index+1] = Math.ceil(newValue * item.cost);
                                                    setSummParams(newSumm);
                                                }} 
                                                value={item.value} 
                                                step={1} 
                                                isDecimal={true}
                                            />
                                        : <SwitcherParams 
                                                name1="Нет" 
                                                name2="Да" 
                                                onChangeValue={(isActive) => {
                                                    setValue(index, isActive ? 1 : 0, "value");
                                                    let newSumm = [...summParams];
                                                    newSumm[index+1] = isActive ? item.cost : 0;
                                                    setSummParams(newSumm);
                                                }}
                                        />    
                                    }</div>
                                </div>
                                <div className="summ">{formatNumber(item.isMulti ? Math.ceil(item.value * item.cost) : (item.value == 1 ? item.cost : 0))} ₽</div>
                            </li> )}
                        </ul>
                        <div className="summ">
                            <div className="text">Итого:</div>
                            <div className="value">{formatNumber(summParams.reduce((summ, item) => summ = summ + item, 0))} ₽</div>
                        </div>
                    </div>
                </div>
                { isTaskView 
                    ? <div className="contentSetupBlock">
                        <div>
                            <div className="title">Таблица тарифных опций</div>
                            <div className="tableContainer">
                                <div className="tableSettings">
                                    <div className="left_side"></div>
                                    <div className="right_side">
                                        <button className="defaultButton disabled"><Filter/></button>
                                        <button className="defaultButton disabled"><Find/></button>
                                        { store.userInfo && store.userInfo.isLicensed == true && <button className="activeButton" onClick={addingValue}>Добавить <Plus/></button> }
                                    </div>
                                </div>
                                <div className="setupCardTable">
                                    <div className="cardTableHeader">
                                        <div className="left">
                                            <div className="num">№</div>
                                            <div className="name">Регулярные операции</div>
                                        </div>
                                        <div className="tdContainer">Множественное</div>
                                        <div className="right" style={{ paddingRight: "65px" }}>
                                            <div className="tdContainer">
                                                <div className="title">Сумма</div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="list">
                                        {objectsList && objectsList.length > 0 && objectsList.map((item, index) => 
                                            <RateOptionsCard 
                                                value={item} 
                                                setValue={(newValue, field) => setValue(index, newValue, field)}
                                                saveValue={(value) => saveValue(value)}
                                                onDelete={() => removeValue(index)}
                                                index={objectsList.length - index - 1}
                                                key={item+index}
                                            />
                                        )}
                                        {newCell && <RateOptionsCard 
                                            value={newCell} 
                                            setValue={(newValue, field) => setValueNewCell(newValue, field)}
                                            saveValue={(newValue) => saveNewCell(newValue)}
                                            onDelete={() => setNewCell(null)}
                                            index={-1}
                                            isNew={true}
                                        />}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <div className="contentSetupBlock">
                        <div>
                            <div className="title">Займы</div>
                            <div className="block_twoFields" style={{ maxWidth: "max-content" }}>
                                <div style={{ maxWidth: "max-content" }}>
                                    <div className="title">Вносим мы</div>
                                    <div className="list">
                                        <ParamField 
                                            title="Время на 1 документ" 
                                            value={loan}
                                            setValue={(newValue) => {
                                                // setParams({ ...params, me: { ...params.me, time_doc: newValue }});
                                                // saveValue({ ...params, me: { ...params.me, time_doc: newValue }});
                                                setLoan(newValue)
                                                updateLoan(newValue)
                                            }}
                                            disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="title">Диапазон количества документов</div>
                            <div className="block_table">                                    
                                { isLoading == false && <SingleTable header={{ title: "Кол-во документов", list: [{ name: "Стомость" }] }}>
                                    {loans.docs_count.map((item, index) => 
                                        <SingleRow values={{ title: item.name, list: [formatNumber(Math.ceil(item.value * loan * (rate_hourCost / 60))) + " ₽"]}} key={item+index}/>
                                    )}
                                </SingleTable> }
                            </div>
                        </div>
                    </div> 
                }
            </div>
        </div>
    )
}

export default observer(RateOptions);
